import type { RaRecord } from "ra-core";
import { productFullName, type Product } from "../../models";
import { ReferenceField, type ReferenceFieldBaseProps } from "./reference-field";
import { ProductIcon } from "../resource-icon";

// @ts-expect-error
export interface ProductFieldProps<T extends RaRecord> extends ReferenceFieldBaseProps<T, Product> {
    reference?: string;
}

export function ProductField<T extends RaRecord>({ source, ...rest }: ProductFieldProps<T>) {
    return (
    <ReferenceField<T, Product>
        source={source}
        reference="product"
        render={x => <>
            <ProductIcon
                image={{ src: x.image, title: x.name }}
                type={x.type}
            /> { productFullName(x, true)}
            </>
                }
        {...rest}
    />
    )
}